<template>
  <div class="search">
    <form action="/" style="background: #fff">
      <van-search
        v-model="name"
        show-action
        placeholder="请输入搜索关键词"
        autofocus
        @search="onSearch"
        @cancel="onCancel"
        @clear="onClear"
      />
    </form>
    <div class="main" v-if="list.length>0">
      <div class="list flex">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="todetail(item)"
          class="mt-10"
          :class="{ mr8: index % 3 != 2 }"
        >
          <div class="rel posterimg">
            <img :src="item.imgUrl" class="imgs" />
            <img
              src="../../assets/img/card/istop.png"
              alt=""
              v-if="item.isTop"
              class="istop"
            />
          </div>
          <div class="name van-ellipsis">{{ item.name }}</div>
        </div>
      </div>
      <div class="bottom1" @click="getmore" v-if="!isfinished">
        加载更多
        <img
          src="../../assets/img/card/down.svg"
          class="down"
          style="width: 15px; height: 15px"
        />
      </div>
      <div class="bottom1" v-else>已经到底了</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Search } from "vant";
import { poster } from "@/api/poster";
Vue.use(Search);

export default {
  data() {
    return {
      list: [],
      isfinished:false,
      page:0,
      name:'',//搜索条件
    };
  },
  methods: {
    // 海报列表
    getlist() {
      if (this.isfinished) {
        return;
      }
      let data = {
        enabled: 1,
        page:this.page,
        size: 10,
        name:this.name,
        sort: "isTop,desc",
      };
      poster(data).then((res) => {
        if (res.content.length > 0) {
           this.page++;
            this.list = this.list.concat(res.content);
        } else {
          this.isfinished = true;
        }
      });
    },
    onSearch(){
        this.list=[]
        this.page=0
        this.isfinished=false
        this.getlist()
    },
    onCancel(){
        this.$router.go(-1)
    },
    onClear(){
        console.log(12)
         this.list=[]
        this.page=0
        this.isfinished=false
        // this.getlist()
    },
    getmore(){
        this.getlist()
    },
    todetail(itm) {
      this.$router.push({path:'/postersetting',query:{...itm}})
    },
  },
  mounted() {
    // this.getlist();
  },
};
</script>
<style lang="less" >
.search {
  width: 100%;
  .van-search {
    background: #fff;
  }
  .main {
    width: 358px;
    // height: 800px;
    font-family: Roboto;
    border: 1px solid rgba(255, 255, 255, 100);
    border-radius: 2px;
    margin: 20px auto;
    background: #fff;
    .list {
      flex-wrap: wrap;
      margin: 9px 8px 0;
      .mr8 {
        margin-right: 8px;
      }
      .posterimg {
        width: 108px;
        height: 149px;
        border-radius: 3px 3px 0px 0px;
        border: 1px solid rgba(237, 237, 237, 100);
        border-bottom: 0;
        overflow: hidden;
        .imgs {
          width: 100%;
          height: 100%;
        }
      }
      .istop {
        width: 55px;
        height: 55px;
        position: absolute;
        right: 0;
        top: 0;
      }
      .name {
        width: 108px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border: 1px solid rgba(237, 237, 237, 100);
        // border-top: 0;
      }
    }
  }
  .bottom1 {
      width: 100%;
      height: 56px;
      line-height: 56px;
      color: rgba(16, 16, 16, 100);
      font-size: 15px;
      text-align: center;
      font-family: SourceHanSansSC-regular;
    }
}
</style>